// Anlegen einer Aufgabe. Tasks hat nur Model-Level-@auth — leere optionale Felder
// werden im Input weggelassen statt mit ""/" " belegt (siehe crm-migration.md 1.4).
export const createTasks = /* GraphQL */ `
  mutation CreateTasks($input: CreateTasksInput!) {
    createTasks(input: $input) {
      id
      createdAt
      subject
      body
      taskType
      status
      priority
      dueDate
      completedAt
      reminderMinutesBefore
      assignedUserId
      companyID
      contactPersonId
      objectID
      objectType
      associatedObjectIds
      associatedObjects
      activityIDs
      originActivityID
      # KEINE company-/contactPerson-Bloecke mehr: Tasks hat keine @hasOne-
      # Verbindungen (Schema, Ressourcenlimit). Der Aufrufer schickt die Antwort durch
      # hydrateTask aus helpers/tasks.js — sonst steht in der Zeile die ALTE Firma
      # und der alte Kontakt.
      # Anhaenge, denormalisiert am Datensatz (Documents ohne @hasMany, siehe Schema).
      documents {
        id
        name
        fileType
        type
      }
    }
  }
`;

// Kontakte der Firma — für Anruf- und Mail-Aufgaben nicht Deko, sondern nötig:
// ohne contactPersonId zeigt die Work Session „Kein Kontakt verknüpft" und weder
// Wähl-Button noch mailto:.
// Mögliche Bearbeiter einer neuen Aufgabe.
//
// Nicht listContactPersons: das Model erlaubt per Schema nur API-Key, ein
// Cognito-Aufruf endet mit „Not Authorized" (siehe helpers/contactPersons.js).
// Dieser Lambda-Weg ist der vorgesehene und wird von allen anderen Formularen
// benutzt.
//
// Angenehmer Nebeneffekt: der Resolver holt genau den angefragten Typ plus "cs".
// Ehemalige Mitarbeiter tragen type "former" und fallen damit strukturell heraus —
// der frühere clientseitige Filter auf `type !== "former"` ist überflüssig geworden.
export const customListContactPersons = /* GraphQL */ `
  query CustomListContactPersons($type: String, $country: String) {
    customListContactPersons(type: $type, country: $country) {
      id
      firstName
      lastName
      email
      type
    }
  }
`;

export const companiesContactPersonsByCompanyID = /* GraphQL */ `
  query ContactsByCompany($companyID: ID!, $nextToken: String) {
    companiesContactPersonsByCompanyID(
      companyID: $companyID
      limit: 200
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        email
        position
      }
      nextToken
    }
  }
`;

export const customerRequestsByCompanyID = /* GraphQL */ `
  query CustomerRequestsByCompanyID($companyID: ID!) {
    customerRequestsByComanyIdByCreatedAt(
      companyID: $companyID
      sortDirection: DESC
      limit: 100
    ) {
      items {
        id
        number
        createdAt
        currentStatus
        customerRequestItems(limit: 5) {
          items {
            id
            title
            item {
              coverImageId
              itemsHead {
                coverImageId
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const getCompanyBasic = /* GraphQL */ `
  query GetCompanyBasic($id: ID!) {
    getCompanies(id: $id) {
      id
      name
      type
    }
  }
`;


// Aufgabe aendern. Tasks hat nur Model-Level-@auth — `null` darf hier frei durch, es
// ist das Mittel, ein geleertes Feld wirklich zu leeren (kein ""/" "-Sentinel).
export const updateTasks = /* GraphQL */ `
  mutation UpdateTasks($input: UpdateTasksInput!) {
    updateTasks(input: $input) {
      id
      createdAt
      subject
      body
      taskType
      status
      priority
      dueDate
      completedAt
      reminderMinutesBefore
      assignedUserId
      companyID
      contactPersonId
      objectID
      objectType
      associatedObjectIds
      associatedObjects
      activityIDs
      originActivityID
      # KEINE company-/contactPerson-Bloecke mehr: Tasks hat keine @hasOne-
      # Verbindungen (Schema, Ressourcenlimit). Der Aufrufer schickt die Antwort durch
      # hydrateTask aus helpers/tasks.js — sonst steht in der Zeile die ALTE Firma
      # und der alte Kontakt.
      # Anhaenge, denormalisiert am Datensatz (Documents ohne @hasMany, siehe Schema).
      documents {
        id
        name
        fileType
        type
      }
    }
  }
`;

export const deleteTasks = /* GraphQL */ `
  mutation DeleteTasks($input: DeleteTasksInput!) {
    deleteTasks(input: $input) {
      id
    }
  }
`;

// Gegenrichtung loesen, bevor die Aufgabe verschwindet: `Activities.taskID` zeigt auf
// sie zurueck (helpers/activities.js) und der Verlauf baut daraus den Link „Zur
// Aufgabe" — ohne dieses Loesen zeigt er auf ein Nichts.
//
// "" und NICHT null: `Activities` traegt Field-Level-@auth (an userId,
// companyOwnerUserId, leadShare), und damit ist `nullAllowedFields` leer — ein null
// in IRGENDEINEM Feld endet als „Unauthorized on taskID" (CLAUDE.md). taskID hat
// keinen Index, deshalb "" und nicht " ".
export const clearActivityTaskLink = /* GraphQL */ `
  mutation UpdateActivities($input: UpdateActivitiesInput!) {
    updateActivities(input: $input) {
      id
      taskID
    }
  }
`;

// Eine Aufgabe zum Bearbeiten nachladen — fuer den Sprung "Zur Aufgabe" aus einer
// Aktivitaet heraus. Dieselben Felder wie die Mutationen oben, weil dasselbe Formular
// sie vorbelegt.
export const getTaskForEdit = /* GraphQL */ `
  query GetTasks($id: ID!) {
    getTasks(id: $id) {
      id
      createdAt
      subject
      body
      taskType
      status
      priority
      dueDate
      completedAt
      reminderMinutesBefore
      assignedUserId
      companyID
      contactPersonId
      objectID
      objectType
      associatedObjectIds
      associatedObjects
      activityIDs
      originActivityID
      # Firma und Kontakt traegt hydrateTask (helpers/tasks.js) nach — Tasks hat
      # keine @hasOne-Verbindungen mehr.
      # Anhaenge, denormalisiert am Datensatz (Documents ohne @hasMany, siehe Schema).
      documents {
        id
        name
        fileType
        type
      }
    }
  }
`;

// Wie `clearActivityTaskLink`, nur auf der Mail-Seite: eine Mail-Aufgabe zeigt mit
// `activityIDs` auf ihre `Emails`-Zeile(n), und die zeigen mit `taskID` zurueck.
//
// "" und NICHT null, aus demselben Grund: `Emails` traegt Field-Level-@auth (userId,
// companyOwnerUserId, leadShare), damit ist `nullAllowedFields` leer und ein null in
// IRGENDEINEM Feld endet als "Unauthorized on taskID". taskID hat keinen Index, deshalb
// "" und nicht " ".
export const clearEmailTaskLink = /* GraphQL */ `
  mutation UpdateEmails($input: UpdateEmailsInput!) {
    updateEmails(input: $input) {
      id
      taskID
    }
  }
`;
